import React from 'react';
import {
  Container,
  Header,
  Icon,
  Title,
  Description,
  HeaderTitle,
} from './InputGroup.styled';
import InfoContainer from './InfoContainer';

const FormSection = ({
  className,
  IconComponent,
  title,
  description = null,
  children,
  infoContainer = false,
}) => {
  return (
    <Container className={className}>
      <Header>
        <HeaderTitle>
          <Icon as={IconComponent} />
          <Title>{title}</Title>
        </HeaderTitle>
        {infoContainer && <InfoContainer />}
        {description && <Description>{description}</Description>}
      </Header>
      {children}
    </Container>
  );
};

export default FormSection;
